import { darken, getContrastRatio, lighten, type Theme } from '@mui/material/styles';

// WCAG standard for text contrast
export const MIN_CONTRAST_RATIO = 4.5;

export function getAccessibleTextColor(theme: Theme, bgColor: string, textColor: string): string {
    let adjustedTextColorDarken = textColor;
    let adjustedTextColorLighten = textColor;
    let contrastDarken = getContrastRatio(bgColor, adjustedTextColorDarken);
    let contrastLighten = getContrastRatio(bgColor, adjustedTextColorLighten);

    // Darken text color until contrast is good enough
    while (contrastDarken < MIN_CONTRAST_RATIO) {
        const newAdjustedTextColorDarken = darken(adjustedTextColorDarken, 0.05);
        const newContrastDarken = getContrastRatio(bgColor, newAdjustedTextColorDarken);

        if (newContrastDarken >= MIN_CONTRAST_RATIO || adjustedTextColorDarken === newAdjustedTextColorDarken) {
            break;
        } else {
            adjustedTextColorDarken = newAdjustedTextColorDarken;
            contrastDarken = newContrastDarken;
        }
    }

    // Lighten text color until contrast is good enough
    while (contrastLighten < MIN_CONTRAST_RATIO) {
        const newAdjustedTextColorLighten = lighten(adjustedTextColorLighten, 0.05);
        const newContrastLighten = getContrastRatio(bgColor, newAdjustedTextColorLighten);

        if (newContrastLighten >= MIN_CONTRAST_RATIO || adjustedTextColorLighten === newAdjustedTextColorLighten) {
            break;
        } else {
            adjustedTextColorLighten = newAdjustedTextColorLighten;
            contrastLighten = newContrastLighten;
        }
    }

    // Choose the color with the biggest contrast
    return contrastDarken > contrastLighten ? adjustedTextColorDarken : adjustedTextColorLighten;
}
